<template>
  <div class="party-affairs">
    <div class="choose-state">
      <span
        v-for="(choose,index) in chooses"
        :key="choose.name"
        @click="active(index,choose.name)"
        :class="isClass==index?'choose':''"
      >{{choose.name}}</span>
    </div>
    <!-- 教学动态 和 课程安排  -->
    <div
      class="public-list-template"
      v-for="data in datas"
      :key="data.id"
      @click="goDetail(data.id)"
      v-show="isClass==0 || isClass==1"
    >
      <div class="news-left">
        <img :src="data.photo | img" alt v-show="data.photo==null?false:true" />
      </div>
      <div class="news-right">
        <p>{{data.headline}}</p>
        <p>
          <!-- <span style="margin-right:.5rem;">浏览:{{data.sees}}</span>
          <span>点赞:{{data.praise}}</span>-->
          <span style="float:right;margin-right:.3rem">{{data.createtime|times}}</span>
        </p>
      </div>
    </div>

    <div class="msg-box"  v-show="isClass==2">
        <div class="msg-template" v-for="(sign,index) in signs" :key="index">
          <div class="msg-left">
            <img :src="sign.photo | img " alt />
          </div>
          <div class="msg-right">
            <div class="msg-first">{{sign.post}} {{sign.name}}</div>
            <div class="msg-second">
              <span style="color:#eb3a26;margin-right:.4rem">{{sign.phone}}</span>
              <span
                class="el-icon-phone"
                style="background:#eb3a26;color:#fff;padding:.1rem .2rem;border-radius: .08rem;"
                @click="call(sign.c4phone)"
              >我要联系</span>
            </div>
            <div class="msg-third">
              <p v-html="sign.memo"></p>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chooses: [
        { name: "教学动态" },
        { name: "课程安排" },
        { name: "师资力量" }
      ],
      isClass: 0,
      datas: [],
      name: "教学动态",
      signs: [],
    };
  },

  mounted: function() {
    console.log(this.name);
    
    this.render();
  },
  methods: {
    active(index, name) {
      this.isClass = index;
      this.name = name;
      sessionStorage.setItem("remoteedu",this.name);
      sessionStorage.setItem("remoteeduIndex",this.isClass);
      this.render();
      
    },
    render() {
      if(sessionStorage.getItem('remoteedu')!=null){
        this.name = sessionStorage.getItem('remoteedu')
        this.isClass = sessionStorage.getItem('remoteeduIndex')
      }
      this.axios
        .post("/api/Party/News", {
          headline: this.$route.query.title,
          duty: this.name,
          post: sessionStorage.getItem("token")
        })
        .then(e => {
          console.log(e.data);
          this.datas = [];
          if (e.data.code == 0) {
            if (this.isClass != 2) {
              this.datas = e.data.msg;
            } else {
              this.signs = e.data.msg;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    goDetail(newsid) {      
      this.$router.push({
        path: "/publicDetail",
        query: { title: "新闻动态", id: newsid, dbnum: 2 }
      });
    },
    call(phone) {
      location.href = `tel:${phone}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.party-affairs {
  .msg-box {
    .msg-template {
      margin: 0.2rem 0;
      background: #fff;
      display: flex;
      // align-items: center;
      .msg-left {
        img {
          width: 2.4rem;
          height: 3rem;
        }
        width: 2.4rem;
        height: 3rem;
        margin: 0 0.2rem;
      }
      .msg-right {
        margin-right: 0.2rem;
        .msg-first {
          font-weight: 600;
          margin: 0.3rem 0;
        }
        .msg-third {
          margin-top: 0.2rem;
          p {
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
          }
        }
      }
    }
    .sign {
      width: 2rem;
      text-align: center;
      color: #fff;
      background-color: #fcbe54;
      border-radius: 0.04rem;
      padding: 0.1rem 0.2rem;
      margin: 0.5rem 0.2rem 0.2rem 0.2rem;
    }
  }

  .public-list-template {
    font-size: 0.3rem;
    width: 94%;
    margin: 0 auto;
    display: flex;
    margin-top: 0.2rem;
    background: #fff;
    padding: 0.2rem 0;
    //   align-items: center;
    .news-right {
      width: 100%;
      margin-left: 0.2rem;
      p:nth-child(1) {
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        display: -webkit-box;
        margin-bottom: 0.3rem;
        line-height: 1.8;
      }
      p:nth-child(2) {
        border-top: 0.01rem solid #e6e6e6;
        padding-top: 0.2rem;
        color: #999999;
        font-size: 0.26rem;
      }
    }
    .news-left {
      img {
        width: 2.4rem;
        height: 2rem;
      }
    }
  }
  .choose-state {
    .choose {
      color: #000;
      position: relative;
      &::before {
        position: absolute;
        width: 25%;
        height: 0.08rem;
        background: linear-gradient(1deg, #f9b94d 0%, #fdcb76 100%),
          linear-gradient(#ae1717, #ae1717);
        border-radius: 0.1rem;
        left: 37.5%;
        content: "";
        bottom: 0;
      }
    }
    span {
      display: inline-block;
      width: 33%;
      text-align: center;
      line-height: 3;
      color: #999999;
    }
    background: #fff;
    width: 100%;
    white-space: nowrap;
    overflow-x: scroll;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>

